import {useNavigate} from 'react-router-dom';
import Logo from '../../assets/image/dashboard/shop-logo-2.svg';
import CustomButton from '../customButton';
import styles from './header.module.scss';
import {useAuth} from '../../context/authContext';
import {useDispatch} from 'react-redux';
import {toggleModal} from '../../store/redux/postSuccessModal';
import {googleAnalyticsInstance} from '../../utilities/helper/googleAnalitics';
import {generalEvents} from '../../utilities/helper/googleEvent/googleEvent';
const HeaderLogo = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {supplierProfile} = useAuth();
  const handleClick = () => {
    if (!supplierProfile?.store) {
      navigate('/shop/guid');
      return;
    }
    googleAnalyticsInstance.eventGoogleAnalytics(generalEvents.sellers);
    dispatch(
      toggleModal({
        description: `پس از بررسی اطلاعات، ${supplierProfile?.store?.store_type?.title} شما ایجاد خواهد شد.`,
        message: 'اطلاعات شما با موفقیت ثبت شد.',
        show: true,
      }),
    );
  };

  return (
    <>
      <div className={styles['header-logo']}>
        <div className="p-3 px-0 d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center">
            <img src={Logo} alt="logo" />
          </div>
          {supplierProfile?.store &&
            supplierProfile?.store?.store_status !== 'accepted' && (
              <CustomButton
                outLet={true}
                className={styles['header-logo__custom-btn']}
                onClick={handleClick}
              >
                <small>ثبت نام فروشنده</small>
              </CustomButton>
            )}
          {supplierProfile?.lab &&
            supplierProfile?.lab?.lab_status !== 'accepted' && (
              <CustomButton
                outLet={true}
                className={styles['header-logo__custom-btn']}
                onClick={handleClick}
              >
                <small>ثبت نام فروشنده</small>
              </CustomButton>
            )}
          {!supplierProfile?.lab && !supplierProfile?.store && (
            <CustomButton
              outLet={true}
              className={styles['header-logo__custom-btn']}
              onClick={handleClick}
            >
              <small>ثبت نام فروشنده</small>
            </CustomButton>
          )}
        </div>
      </div>
    </>
  );
};

export default HeaderLogo;
